var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExperiences = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Ticket--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Ticket Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2 10.53a1 1 0 0 0 0.8 -1V5.5A1.5 1.5 0 0 0 22.5 4h-21A1.5 1.5 0 0 0 0 5.5v4.05a1 1 0 0 0 0.8 1 1.5 1.5 0 0 1 0 2.94 1 1 0 0 0 -0.8 1v4.01A1.5 1.5 0 0 0 1.5 20h21a1.5 1.5 0 0 0 1.5 -1.5v-4.05a1 1 0 0 0 -0.8 -1 1.5 1.5 0 0 1 0 -2.94ZM5.25 18.25A0.75 0.75 0 1 1 6 17.5a0.76 0.76 0 0 1 -0.75 0.75Zm0 -3.67a0.75 0.75 0 1 1 0.75 -0.75 0.75 0.75 0 0 1 -0.75 0.75Zm0 -3.66a0.75 0.75 0 1 1 0.75 -0.75 0.76 0.76 0 0 1 -0.75 0.75Zm0 -3.67A0.75 0.75 0 1 1 6 6.5a0.76 0.76 0 0 1 -0.75 0.75Zm11.75 9a1.75 1.75 0 1 1 1.75 -1.75A1.75 1.75 0 0 1 17 16.25Zm1.5 -7.5h-9a0.75 0.75 0 0 1 0 -1.5h9a0.75 0.75 0 0 1 0 1.5Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExperiences);
export default ForwardRef;